import { Checkbox } from "@fluentui/react-components";
import { IAttachment } from "../../mailitem/mail-item-types";
import { Tooltip } from "@fluentui/react-tooltip";
import { isItemAttachment } from "../../helpers/ItemAttachmentFileExtensions";
export interface TProps {
  saveToContent?: React.ReactNode;
  attachments: IAttachment[];
  selectedIds: string[];
  toggleSelected: (id: string) => void;
  allSelected: boolean;
  toggleAll: () => void;
}

const selectedInnerClass = "bg-primary-cyan-40";
const selectedOuterClass = "bg-primary-blue-660";

export const AttachmentsPresentational = (props: TProps) => {
  if (!props.attachments || props.attachments.length === 0) {
    return null;
  }

  const getSelectedItemOuterClassName = (isSelected: boolean): string => {
    return isSelected ? selectedOuterClass : "bg-neutral-50 hover:bg-primary-blue-660";
  };

  const getSelectedItemInnerClassName = (isSelected: boolean): string => {
    return isSelected ? selectedInnerClass : "bg-neutral-50";
  };

  const getAllSelectedCheckState = (props: TProps): boolean | "mixed" => {
    if (props.selectedIds.length == props.attachments.length) {
      return true;
    }

    if (props.selectedIds.length == 0) {
      return false;
    }

    return "mixed";
  };

  return (
    <div className="flex flex-col flex-grow bg-neutral-50 w-full h-full">
      <span className="text-neutral-850 font-semibold text-base mx-4 mt-3">Attachments</span>
      {/* Temporarirly disabled until we can re-design folder selection */}
      {/* <div className="mt-1 px-4">{props.saveToContent}</div> */}
      <div className="mt-4 overflow-auto w-full flex-grow scrollbar scrollbar-thumb-rounded-full scrollbar-thumb-neutral-250 hover:scrollbar-thumb-neutral-700 active:scrollbar-thumb-neutral-500 scrollbar-track-transparent">
        {props.attachments.length > 1 && (
          <div
            className="flex items-center cursor-pointer h-10 px-2 border-b border-t border-b-1 border-t-1 border-neutral-150"
            onClick={props.toggleAll}
          >
            <Checkbox className="mt-0" checked={getAllSelectedCheckState(props)} onChange={props.toggleAll} />
            <span className="text-neutral-850 font-semibold text-sm">{props.selectedIds.length} Selected</span>
          </div>
        )}
        <ul className="mb-2">
          {props.attachments.map((attachment, index) => {
            const isSelected = props.selectedIds.includes(attachment.id);
            const outerClassName = getSelectedItemOuterClassName(isSelected);
            const innerClassName = getSelectedItemInnerClassName(isSelected);
            const isItem = isItemAttachment(attachment);
            return (
              <li
                className={`${
                  isItem ? "cursor-not-allowed" : "cursor-pointer"
                } text-nowrap pl-1 border-b border-neutral-150 ${outerClassName} flex min-w-full max-w-full`}
                key={index}
                onClick={() => {
                  if (!isItem) props.toggleSelected(attachment.id);
                }}
              >
                <div className={`flex grow items-center h-10 px-1 w-full ${innerClassName}`}>
                  <Checkbox
                    className="m-0 p-0"
                    checked={isSelected}
                    onChange={() => {
                      if (!isItem) props.toggleSelected(attachment.id);
                    }}
                    disabled={isItem}
                  />

                  <div className="flex grow overflow-hidden items-center">
                    <Tooltip content={attachment.name} relationship="label">
                      <span className="truncate max-w-full">{attachment.name}</span>
                    </Tooltip>
                  </div>

                  {isItem && (
                    <Tooltip
                      content="Outlook Items are not supported as attachments against emails at this time."
                      relationship="label"
                    >
                      <div className="bg-yellow-100 text-yellow-800 text-sm font-medium ms-2 px-2.5 py-0.5 rounded dark:bg-yellow-900 dark:text-yellow-300">
                        Not Supported
                      </div>
                    </Tooltip>
                  )}
                </div>
              </li>
            );
          })}
        </ul>
      </div>
    </div>
  );
};
